import { signal } from '@preact/signals-react';
import { I18nLanguage, getI18nSupportedLanguageList } from '@/i18n/types/i18nLanguage.ts';

const LANGUAGE_STORAGE_KEY = 'userLocalization';

// Get language from localStorage or default to English
const getSavedLanguage = (): I18nLanguage => {
  const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY) as I18nLanguage;
  if (savedLanguage && isValidLanguage(savedLanguage)) {
    return savedLanguage;
  }
  return I18nLanguage.English;
};

// Check if a language is in the supported language list
const isValidLanguage = (language: string): boolean => {
  return getI18nSupportedLanguageList().includes(language as I18nLanguage);
};

// Create signal for current language
export const selectedLanguage = signal<I18nLanguage>(getSavedLanguage());

// Function to update language and save to localStorage
export const setLanguage = (language: I18nLanguage): void => {
  if (isValidLanguage(language)) {
    selectedLanguage.value = language;
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }
};